import * as tslib_1 from "tslib";
import { searchDiagnosticsStore } from 'owa-search-diagnostics';
import { escape } from 'Global';
import { UserVoiceSearchTeam } from '../components/SearchInContextFeedbackDialog';
export default function getSearchFeedbackCustomTags(userVoiceFeedbackTeam) {
    // deep clone the instrumentation list so that original list is not impacted
    var searchInstrumentationEntries = searchDiagnosticsStore.searchInstrumentationList.map(function (a) { return (tslib_1.__assign({}, a)); });
    // Strip out PII data
    searchInstrumentationEntries.forEach(function (instrumentation) {
        delete instrumentation.PIIData;
    });
    var userVoiceFeedbackLocationName = null;
    var userVoiceTeam1 = null;
    switch (userVoiceFeedbackTeam) {
        case UserVoiceSearchTeam.MailSearch:
            userVoiceTeam1 = "OWA 3S Query Feedback" /* Search */;
            userVoiceFeedbackLocationName = 'Owa mail React';
            break;
        case UserVoiceSearchTeam.CalendarSearch:
            userVoiceTeam1 = "OWA Calendar 3S Query Feedback" /* CalendarSearch */;
            userVoiceFeedbackLocationName = 'Owa calendar React';
            break;
    }
    var customTags = (_a = {
            Type: "General Negative" /* Negative */
        },
        _a['Team 1'] = userVoiceTeam1,
        _a.FeedbackLocationName = userVoiceFeedbackLocationName,
        _a.SearchHistory = escape(JSON.stringify(searchInstrumentationEntries)),
        _a);
    return customTags;
    var _a;
}
//# sourceMappingURL=getSearchFeedbackCustomTags.js.map